import { render, staticRenderFns } from "./DeviceCategoryDetail.vue?vue&type=template&id=17dea2aa"
import script from "./DeviceCategoryDetail.vue?vue&type=script&lang=js"
export * from "./DeviceCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports